import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const EditProduct = () => {
  const { id } = useParams(); // get product id from URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    Description: "",
    category: "",
    stock: "",
    images: [],
  });

  const [categories, setCategories] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch product details
  useEffect(() => {
    const fetchProduct = async () => {
  try {
    const res = await axios.get("https://api.taratoys.in/api/products?limit=0");
    const product = res.data.products.find(p => p._id === id);
    if (!product) {
      setError("Product not found.");
      return;
    }
    setFormData({
      name: product.name || "",
  
      Description: product.Description || "",
      category: product.category?._id || "",
  
      images: product.images || [],
    });
    setPreviewImages(
      product.images.map((img) => `https://api.taratoys.in${img}`)
    );
  } catch (err) {
    console.error(err);
    setError("Failed to load product.");
  }
};


    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://api.taratoys.in/api/categories"
        );
        setCategories(res.data.categories || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchProduct();
    fetchCategories();
  }, [id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle new image upload
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({ ...prev, images: [...prev.images, ...files] }));

    const previews = files.map((file) => URL.createObjectURL(file));
    setPreviewImages((prev) => [...prev, ...previews]);
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = new FormData();
      data.append("name", formData.name);
   
      data.append("Description", formData.Description);
      data.append("category", formData.category);
     

      // Append images (new uploads only)
      formData.images.forEach((file) => {
        if (file instanceof File) {
          data.append("images", file);
        }
      });

      await axios.put(
        `https://api.taratoys.in/api/products/${id}`,
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert("Product updated successfully!");
      navigate("/products");
    } catch (err) {
      console.error(err);
      setError("Failed to update product.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Edit Product</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-3">
          <label className="form-label">Product Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

        
        <div className="mb-3">
          <label className="form-label">Description</label>
          <input
            type="text"
            name="Description"
            value={formData.Description}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

      
        <div className="mb-3">
          <label className="form-label">Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Images</label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageChange}
            className="form-control"
          />
        </div>

        <div className="mb-3 d-flex flex-wrap">
          {previewImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="preview"
              style={{
                width: "150px",
                height: "120px",
                objectFit: "cover",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "5px",
              }}
            />
          ))}
        </div>

        <button type="submit" className="btn btn-success" disabled={loading}>
          {loading ? "Updating..." : "Update Product"}
        </button>
      </form>
    </div>
  );
};

export default EditProduct;
